var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIconLaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25936 3.96125C6.16809 6.3088 4.73291 9.68148 4.59964 9.99927L0.888672 8.41032L5.04045 4.25854C5.52226 3.77673 6.21935 3.56145 6.89594 3.69472L8.25936 3.96125ZM10.2891 14.8789C10.2891 14.8789 14.1231 13.2899 16.3271 11.0859C21.8628 5.5502 20.9402 1.22415 20.6429 0.250281C19.6691 -0.0572583 15.343 -0.969624 9.80731 4.56608C7.60327 6.77011 6.01432 10.6041 6.01432 10.6041L10.2891 14.8789ZM16.932 12.6339C14.5844 14.7251 11.2117 16.1603 10.8939 16.2936L12.4829 20.0045L16.6347 15.8528C17.1165 15.371 17.3318 14.6739 17.1985 13.9973L16.932 12.6339ZM8.06458 15.904C8.06458 16.7549 7.71604 17.5237 7.16247 18.0773C5.95282 19.2869 0.888672 20.0045 0.888672 20.0045C0.888672 20.0045 1.60626 14.9404 2.81592 13.7307C3.24524 13.2992 3.79312 13.0049 4.39 12.8853C4.98688 12.7658 5.60583 12.8263 6.16827 13.0591C6.7307 13.292 7.21124 13.6868 7.54888 14.1933C7.88652 14.6998 8.06601 15.2953 8.06458 15.904ZM12.1651 6.67785C12.1651 5.5502 13.0877 4.62759 14.2154 4.62759C15.343 4.62759 16.2656 5.5502 16.2656 6.67785C16.2656 7.80549 15.343 8.72811 14.2154 8.72811C13.0877 8.72811 12.1651 7.80549 12.1651 6.67785Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconLaunch);
export default __webpack_public_path__ + "static/media/buttonIconLaunch.054d633b3bf85e850f06c148649fdfa1.svg";
export { ForwardRef as ReactComponent };